export default "__VITE_ASSET__CagS9k58__"